(function(){
    angular
        .module('appback')
        .directive('ngOnloadrefreshiso', ngOnloadrefreshiso);

        ngOnloadrefreshiso.$inject = ['$timeout'];
        function ngOnloadrefreshiso($timeout){
            return {
	            //require: 'ngModel',
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
						var tmpImg = new Image() ;
					    tmpImg.src = $(element).attr('src') ;
					    tmpImg.onload = function() {
					    	console.log("ONLOAD");
	            			scope.$emit('iso-method', {name:'shuffle', params:null})
					    } ;
		            	
		            	
			        });
		        }
          }
      }
})();